<form name="editSavedQuery" novalidate [formGroup]="form">
    <sq-modal [title]="'msg#editSavedQuery.title'" [buttons]="buttons">
        <div class="mb-3 sq-form-group">
            <label class="form-label" for="savedQueryName">{{'msg#editSavedQuery.name' | sqMessage}}</label>
            <input [sqValidation]="form" type="text" class="form-control" id="savedQueryName" formControlName="savedQueryName" spellcheck="off" sqAutofocus>
        </div>
    </sq-modal>
</form>